/* global __DEV__ */
var inMode;
try {
    inMode = localStorage.getItem('syos.debug')
} catch (e) {} // eslint-disable-line no-empty

export function inDebugMode() {
    return (!!inMode || __DEV__);
}

export function info() {
    if (inDebugMode() && console && console.info) {
        console.info.apply(console, arguments);
    }
}

export default {
    inDebugMode,
    info
}



// WEBPACK FOOTER //
// ./src/javascripts/app/lib/common/debug.js